var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bc500-charts"},[_vm._l((_vm.options),function(config,index){return [_c('ChartItem',_vm._b({key:index,attrs:{"color":_vm.colors[index % 3],"serie-style":_vm.serieStyles[index % 3]}},'ChartItem',config,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }